import * as React from 'react'
import clsx from 'clsx'
import { makeStyles } from 'tss-react/mui'
import { Logger } from 'wdc-cube'
import { FCClassContext, buttonSx, classToFComponent } from 'src/utils/views'

import SearchIcon from '@mui/icons-material/Search'

import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import InputBase from '@mui/material/InputBase'

import { TextualSearchScope } from '../tcm_scopes'

const LOG = Logger.get('TCM-HeaderSearchBar')

const useStyles = makeStyles()(() => ({
    view: {
        display: 'flex',
        flexGrow: 1,
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        minHeight: 43,
        minWidth: 0,
        padding: '0 5px 0 13px',
        borderRadius: 9,
        border: '1px solid rgba(255, 255, 255, .18)',
        backgroundColor: 'rgba(255, 255, 255, .06)',
        transition: 'border-color .15s ease, box-shadow .15s ease',
        '&:focus-within': {
            borderColor: 'var(--green-700)',
            boxShadow: '0 0 0 3px rgba(38, 229, 31, .12)'
        }
    },
    icon: {
        fontSize: 20,
        color: 'rgba(255, 255, 255, .62)',
        flex: '0 0 auto'
    },
    input: {
        flexGrow: 1,
        minWidth: 0,
        fontSize: 14,
        color: '#f4f4f4',
        '& input::placeholder': {
            color: 'rgba(255, 255, 255, .52)',
            opacity: 1,
            textOverflow: 'ellipsis'
        }
    },
    progress: {
        width: '22px !important',
        height: '22px !important',
        color: 'var(--green)',
        marginRight: 6
    }
}))

type HeaderSearchBarProps = {
    className?: string
    scope: TextualSearchScope
}

class HeaderSearchBarViewClass implements FCClassContext<HeaderSearchBarProps> {
    // :: Fields

    scope!: TextualSearchScope
    inputEl?: HTMLInputElement

    // :: Emissors

    readonly emitOnSearch = () => {
        this.scope.text = this.inputEl ? this.inputEl.value : ''
        this.scope.onSearch().catch(LOG.caught)
    }

    readonly emitOnKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (e.key === 'Enter') {
            this.emitOnSearch()
        }
    }

    // :: Methods

    onSyncState({ scope }: HeaderSearchBarProps) {
        this.scope = scope
    }

    render(props: HeaderSearchBarProps): React.JSX.Element {
        const classes = useStyles().classes
        const scope = this.scope

        return (
            <div className={clsx(classes.view, props.className)}>
                <SearchIcon className={classes.icon} aria-hidden="true" />
                <InputBase
                    inputRef={this.inputRef}
                    className={classes.input}
                    placeholder={HELPER_MESSAGE}
                    inputProps={{ 'aria-label': 'Buscar mercado em linguagem natural' }}
                    multiline={false}
                    disabled={scope.waiting}
                    onKeyDown={this.emitOnKeyDown}
                />
                {scope.waiting && <CircularProgress className={classes.progress} />}
                {!scope.waiting && (
                    <Button sx={{ ...buttonSx('brand', true), flex: '0 0 auto' }} onClick={this.emitOnSearch}>
                        Busca IA
                    </Button>
                )}
            </div>
        )
    }

    inputRef = (elm: HTMLInputElement) => {
        this.inputEl = elm
    }
}

const HELPER_MESSAGE =
    'Quero analisar o mercado de empresas de regime simples que ' +
    'trabalham com treinamento profissional ou gerencial em Santa Catarina'

export const HeaderSearchBarView = classToFComponent(HeaderSearchBarViewClass, React)
export default HeaderSearchBarView
